import React, { useMemo } from 'react';
import './styles.scss';

type PaginationItemProps = {
    isCurrent?: boolean;
    number?: number;
    isPreview?: boolean;
    isNext?: boolean;
    onClick?: () => void;
};

const PaginationItem: React.FC<PaginationItemProps> = ({ isCurrent, number: pageNumber, isPreview, isNext, onClick }) => {
    const className = useMemo(() => {
        const classList = ['pagination-item-container'];

        if (isCurrent) {
            classList.push('is-current');
        }

        if (isPreview) {
            classList.push('is-nav-button');
            classList.push('is-preview');
        }

        if (isNext) {
            classList.push('is-nav-button');
            classList.push('is-next');
        }

        return classList.join(' ');
    }, [isNext, isPreview]);

    return (
        <div className={className} onClick={onClick}>
            {isPreview || isNext ? (
                <i className="material-icons align-middle">
                    {isNext && 'chevron_right'}
                    {isPreview && 'chevron_left'}
                </i>
            ) : (
                pageNumber
            )}
        </div>
    );
};

export { PaginationItem };
